import { useMemo } from 'react'

import styled from 'styled-components'

import { pink } from '../../../../../styles/colors'
import { IMapPoint } from '../ManagePoints/ManagedMapPoint'

import { formatLine } from './formatLine'

interface ManualSequencePathProps {
  sequence: number[]
  points: IMapPoint[]
  width?: number
}

export const ManualSequencePath = ({
  sequence,
  points,
  width = 4,
}: ManualSequencePathProps) => {
  const pointsById = useMemo(() => {
    const map = new Map<number, IMapPoint>()
    points.forEach(point => {
      map.set(point.point_id, point)
    })
    return map
  }, [points])

  const segments = useMemo(() => {
    const pairs: Array<{
      key: string
      top: number
      left: number
      height: number
      rotation: number
    }> = []

    for (let i = 0; i < sequence.length - 1; i++) {
      const startPoint = pointsById.get(sequence[i])
      const endPoint = pointsById.get(sequence[i + 1])
      if (!startPoint || !endPoint) {
        continue
      }

      const lineData = formatLine(
        parseFloat(String(startPoint.x)),
        parseFloat(String(startPoint.y)),
        parseFloat(String(endPoint.x)),
        parseFloat(String(endPoint.y)),
      )

      pairs.push({
        key: `${sequence[i]}-${sequence[i + 1]}-${i}`,
        ...lineData,
      })
    }

    return pairs
  }, [pointsById, sequence])

  if (sequence.length < 2) {
    return null
  }

  return (
    <>
      {segments.map(segment => (
        <PathSegment
          key={segment.key}
          $width={width}
          style={{
            top: segment.top,
            left: segment.left,
            height: segment.height,
            transform: `rotate(${segment.rotation}deg)`,
          }}
        />
      ))}
    </>
  )
}

const PathSegment = styled.div<{ $width: number }>`
  pointer-events: none;
  position: absolute;
  box-sizing: content-box;
  background-color: ${pink};
  width: ${props => props.$width}px;
  margin-left: ${props => -props.$width / 2}px;
  z-index: 1;
  opacity: 0.85;
`
